import {PipelineGraphQL, PipelineEdge, PipelineStep} from 'pipelines/PipelineTypes';

import {
  AnalysisGraphNode,
  AnalysisGraphNodeType,
  AnalysisGraphEdge,
  AnalysisGraphEdgeType,
  AnalysisGraph,
} from './AnalysisGraphTypes';
import AnalysisGraphUtils from './AnalysisGraphUtils';

function createNodes(steps: Array<PipelineStep>): Array<AnalysisGraphNode> {
  return steps.map((step) => ({
    id: AnalysisGraphUtils.getNodeId(step),
    data: {step},
    position: {x: 0, y: 0},
    type: AnalysisGraphNodeType.STEP,
  }));
}

function createEdges(steps: Array<PipelineStep>): Array<AnalysisGraphEdge> {
  return steps
    .flatMap((parentStep) => parentStep.outgoingEdges)
    .map((edge: PipelineEdge) => ({
      id: AnalysisGraphUtils.getEdgeId(edge),
      data: AnalysisGraphUtils.getEdgeData(steps, edge),
      source: AnalysisGraphUtils.getNodeId(edge.fromStep),
      target: AnalysisGraphUtils.getNodeId(edge.toStep),
      sourceHandle: AnalysisGraphUtils.getHandleId(edge.fromStepData),
      targetHandle: AnalysisGraphUtils.getHandleId(edge.toStepData),
      type: AnalysisGraphEdgeType.EDGE,
    }));
}

/**
 * Create the flowchart graph of an analysis
 */
export default function createAnalysisGraph({steps}: Pick<PipelineGraphQL, 'steps'>): AnalysisGraph {
  const nodes = createNodes(steps);
  const edges = createEdges(steps);

  return {nodes, edges};
}
